import { KEYS_USERS_STATS } from '@config/storeKeys.js'
import { store } from '@stores'
import { computed } from 'vue'

const { getStore, createStore } = store()

export default function () {
  const key = KEYS_USERS_STATS

  function getUserStats(nameId) {
    const stats = getStore(key)
    return computed(() => stats.value?.[nameId] || null)
  }

  function addUserStats(nameId, stats) {
    const allStats = getStore(key)
    if (!allStats.value) createStore(key, {})
    const userStats = { ...allStats.value[nameId], ...stats }
    const newAllStats = { ...allStats.value, [nameId]: userStats }
    createStore(key, newAllStats)
  }

  return {
    getUserStats,
    addUserStats,
  }
}
